export const COMPANY_SIZES = ['1-5', '5-20', '20-50', '50-200', '200-1000', '1000+'] as const;
export type CompanySize = (typeof COMPANY_SIZES)[number];
/** What the picker shows. The stored ranges share their ends ("1-5", "5-20"); the labels don't. */
export const COMPANY_SIZE_LABELS: Record<CompanySize, string> = {
  '1-5': '1–5',
  '5-20': '6–20',
  '20-50': '21–50',
  '50-200': '51–200',
  '200-1000': '201–1,000',
  '1000+': 'More than 1,000',
};

export interface SignupProfile {
  name: string;
  company: string;
  phone: string;
  companySize: CompanySize;
  terms: boolean;
  whatsappNotifications?: boolean;
}
